import { adminHttpClient } from '../../../commons/adminHttpClient'

const deleteExpenseApi = (expenseId: string): Promise<any> => {
  return adminHttpClient.delete('/EEDashboard/GetReimbursed/Expense/RemoveExpense', {
    data: {
      expenseId: expenseId,
    },
  })
}

export default deleteExpenseApi
